import { SERVICES_MENU_VARIANTS } from "../ServicesMenuChapter.interface";
import SectionLayoutVariant1 from "./SectionLayoutVariant1";
import SectionLayoutVariant2 from "./SectionLayoutVariant2";
import { SectionLayoutProps } from "./SectionLayout.constants";
import SectionLayoutVariant3 from "./SectionLayoutVariant3";
import SectionLayoutVariant4 from "./SectionLayoutVariant4";
import SectionLayoutVariant5 from "./SectionLayoutVariant5";
import SectionLayoutVariant6 from "./SectionLayoutVariant6";

function SectionLayout(props: SectionLayoutProps) {
    const {
        section,
    } = props;
    const {
        variant,
    } = section;

    switch (variant) {
        case SERVICES_MENU_VARIANTS.VARIANT_6:
            return <SectionLayoutVariant6 {...props} />
        case SERVICES_MENU_VARIANTS.VARIANT_5:
            return <SectionLayoutVariant5 {...props} />
        case SERVICES_MENU_VARIANTS.VARIANT_4:
            return <SectionLayoutVariant4 {...props} />
        case SERVICES_MENU_VARIANTS.VARIANT_3:
            return <SectionLayoutVariant3 {...props} />
        case SERVICES_MENU_VARIANTS.VARIANT_2:
            return <SectionLayoutVariant2 {...props} />
        default:
            return <SectionLayoutVariant1 {...props} />
    }
}

export default SectionLayout;
